import classNames from 'classnames';
import React from 'react';

import * as ReviewUtil from 'notebook/reviews/ReviewUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {Review} from './ReviewConstants';

export interface StageEntryReviewBadgeProps {
  className?: string;
  review?: Review;
}

export function StageEntryReviewBadge({review, className}: StageEntryReviewBadgeProps): JSX.Element {
  return (
    <span
      className={classNames('reviewBadge', ReviewUtil.getStatusCSSClassFromReview(review?.status), className)}
      {...getTestProps({component: 'StageEntryReviewBadge', element: 'root'})}
    >
      <BenchlingIcon className="reviewBadge-icon" icon={ReviewUtil.getStatusIcon(review?.status)} />
      {ReviewUtil.getStatusTextFromReview(review?.status)}
    </span>
  );
}

export default StageEntryReviewBadge;
